export default "__VITE_ASSET__DOTWPkHP__"